import { customElement, property } from "lit/decorators.js";
import { LitElementBase } from "../LitElementBase";
import { css, html, nothing, PropertyValues } from "lit";
import { inViewport } from "../../util/domutils";

@customElement("ehm-search")
export class Search extends LitElementBase {
  #searchButtons: NodeListOf<HTMLButtonElement> | null = null;
  @property({ type: Boolean, reflect: true }) open = false;

  static styles = css`
    .search {
      position: absolute;
      top: var(--menu-offset, 6rem);
      right: 0;
      left: 0;
      z-index: 1000;
      background-color: var(--bg-primary-white);
      display: none;
      border-top: 1px solid var(--border-grey);
      margin-top: -1px;
    }
    :host([open]) .search {
      display: block;
    }
    :host([open]) .backdrop {
      opacity: 1;
    }
    .backdrop {
      position: fixed;
      opacity: 0;
      top: var(--menu-offset, 6rem);
      left: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(3px);
      z-index: 999;
      transition: opacity 300ms ease-in-out;
    }
    @starting-style {
      :host([open]) .backdrop {
        opacity: 0;
      }
    }
  `;

  constructor() {
    super();
    this.#searchButtons = document.querySelectorAll(`button[aria-controls="${this.id}"]`);
    this.#searchButtons.forEach((button) => {
      button.addEventListener("click", () => (this.handleOpen()));
      button.setAttribute("aria-expanded", "false");
    });
  }

  updated(changedProperties: PropertyValues) {
    const prevOpen = changedProperties.get("open");
    const params = new URLSearchParams(window.location.search);

    if (prevOpen === undefined) {
      if (params.get("search") === "open") {
        this.open = true;
      }
      return;
    }

    if (prevOpen) {
      this.#closeDrawer(params);
    } else {
      this.#openDrawer(params);
    }

    window.history.replaceState(null, "", `?${params.toString()}`);
  }

  handleOpen() {
      this.open = !this.open
        if (document.querySelector(".vma")) {
          const vmas = document.querySelectorAll(".vma") as NodeListOf<HTMLElement>;
          let totalVmaHeight = 0;
          vmas.forEach(vma => {
            totalVmaHeight += inViewport(vma);
          })
          totalVmaHeight += (document.querySelector("header") as HTMLElement).offsetHeight;
          (this.shadowRoot?.querySelector(".backdrop") as HTMLElement).style.top = totalVmaHeight + "px";
        }
    }

  #openDrawer(params: URLSearchParams) {
    params.set("search", "open");
    this.#setsearchButtonState(true);
    this.#toggleInertElements(true);
    this.#addEventListeners();
    this.querySelector("input")?.focus();
  }

  #closeDrawer(params: URLSearchParams) {
    params.delete("search");
    this.#setsearchButtonState(false);
    this.#toggleInertElements(false);
    this.#removeEventListeners();
  }

  #setsearchButtonState(expanded: boolean) {
    this.#searchButtons?.forEach((button) => {
      button.setAttribute("aria-expanded", expanded.toString());
    });
  }

  #toggleInertElements(inert: boolean) {
    const elements = document.querySelectorAll(".inert-on-nav");
    elements.forEach((el) => {
      if (inert) {
        el.setAttribute("inert", "");
      } else {
        el.removeAttribute("inert");
      }
    });
  }

  #addEventListeners() {
    setTimeout(() => {
      document.querySelector(".wrapper.header__inner")?.addEventListener("click", this.#handleBackdropClick);
      document.addEventListener("keydown", this.#handleEscKey);
    }, 100);
  }

  #removeEventListeners() {
    document.querySelector(".wrapper.header__inner")?.removeEventListener("click", this.#handleBackdropClick);
    document.removeEventListener("keydown", this.#handleEscKey);
  }

  #handleBackdropClick = () => {
    this.open = false;
  };

  #handleEscKey = (e: KeyboardEvent) => {
    if (e.key === "Escape") {
      this.open = false;
    }
  };

  render() {
    return html`
      <div class="search" part="dialog">
        <slot></slot>
      </div>
        <div class="backdrop ${this.open ? "" : "hidden"}" part="backdrop" @click=${this.#handleBackdropClick}></div>
    `;
  }
}
